/**
 * Main scripts, loaded on all pages.
 *
 * @package atlanticlottery
 */

// import '../sass/main.scss';

import $ from 'jquery';
import WebFontLoader from 'webfontloader';

import './components/foundation-explicit-pieces';
import './components/navigation';

// import 'slick-carousel';
$( document ).foundation();

// Load Custom Fonts
WebFontLoader.load( {
	google: {
		families: [
			'Open Sans:300,400,700',
			'Lato: 400,700'
		]
	}
} );

// Append Filter Button.
$( '.widget-area' ).prepend( '<button class="products-filter close"><i class="fal fa-times"></i></button>' );

// Products Filter Toggle.
$( document ).on( 'click', '.products-filter', function() {

	let body = $( 'body' );
	let widget = $( '.widget-area' );

	body.toggleClass( 'active' );
	widget.toggleClass( 'active' );

} );

// Mobile Toggle.
$( document ).on( 'click', '.mobile-toggle', function() {

	let that = $( this );
	let body = $( 'body' );
	let flyout = $( '.flyout-navigation-wrapper' );
	let search = $( '.site-search' );

	if ( that.hasClass( 'flyout-toggle' ) ) {

		flyout.toggleClass( 'active' );
		search.slideUp();
		body.toggleClass( 'active' );

	} else if ( that.hasClass( 'search-toggle' ) ) {

		search.slideToggle();

	}
} );

// My Account Menu Slide Toggle.
$( document ).on( 'click', '.menu.my-account-menu .menu-item-has-children > a', function( event ) {

	event.preventDefault();

	if ( 768 > $( window ).width() ) {

		$( '.menu.my-account-menu .sub-menu' ).slideToggle();
		$( this ).toggleClass( 'active' );

	}

} );

// Accordion Block Slide Toggle.
$( document ).on( 'click', '.accordion-title', function( event ) {

	event.preventDefault();

	$( this ).toggleClass( 'active' );
	$( this ).parent().next( '.accordion-content' ).slideToggle();

} );

$( document ).on( 'click', '.close-announcement', function() {
	$( '.announcement-block' ).slideUp();
} );

// $( '.slick-slider' ).slick();
